<template>
    <div>
        <md-table md-height="80%" v-model="searched" md-sort="id" md-sort-order="asc" md-card md-fixed-header @md-selected="onSelect">
            <md-table-toolbar>
                <div class="md-toolbar-section-start">
                    <h1 class="md-title">Jobs</h1>
                </div>

                <md-field md-clearable class="md-toolbar-section-end">
                    <md-input placeholder="Search by date name..." v-model="search" @input="searchOnTable" />
                </md-field>
            </md-table-toolbar>

            <md-table-empty-state
                    md-label="No jobs found"
                    :md-description="`No job found for this '${search}' query. Try a different search term.`">
            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                <md-table-cell md-label="ID" md-sort-by="id" md-numeric>{{ item.id }}</md-table-cell>
                <md-table-cell md-label="Process" md-sort-by="process">{{ item.process }}</md-table-cell>
                <md-table-cell md-label="Frequency" md-sort-by="frequency">{{ item.frequency }}</md-table-cell>
                <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
            </md-table-row>
        </md-table>
    </div>
</template>

<script>
    import moment from 'moment'

    const toLower = text => {
        return text.toString().toLowerCase()
    }

    const searchByName = (items, term) => {
        if (term) {
            return items.filter(item => toLower(item.name).includes(toLower(term)))
        }
        return items
    }

    const maxSizeOfJobs = 30

    export default {
        name: "ListTickets",
        data: () => (
            {
                selected: [],
                search: null,
                searched: [],
                listJobs: []
            }
        ),
        methods: {
            onSelect (items) {
                console.log(items)
                // this.$router.push({ name: 'ListStatusPerJob', params: { dateName: items.name } })
                this.$router.push({path:'/jobs', query:{dateName: items.name}})

            },
            searchOnTable () {
                this.searched = searchByName(this.listJobs, this.search)
            },
            listJobsToReview(){

                let job = {}
                for (let i = 0; i <= maxSizeOfJobs; i++) {
                    let jobDate = moment().subtract(i, 'day').format('YYYY-MM-DD');
                    job = {
                        id: i+1,
                        process: "Crossbow",
                        frequency: "Nightly",
                        name: "nightly-" + jobDate + "-0"
                    }
                    this.listJobs.push(job)
                    job = {}
                }
                this.searched = this.listJobs
            }
        },
        created() {
            this.listJobsToReview();
        },
        mounted(){
            this.$el.childNodes[0].childNodes[6].attributes[1].value = "";
        }
    }
</script>

<style lang="scss" scoped>
</style>
